const VALUE_TYPE = 'value' as const;
const CATEGORY_TYPE = 'category' as const;
const ALIGN_RIGHT = 'right' as const;

export const formatAxis = (
  axisData: (string | number)[],
  isHorizontal: boolean = false,
  {
    axisLabels,
    chartHeight,
    chartWidth,
  }: { axisLabels?: string[]; chartHeight?: number; chartWidth?: number } = {}
) =>
  isHorizontal
    ? {
        xAxis: {
          type: VALUE_TYPE,
          name: axisLabels?.[1],
          nameLocation: 'middle' as const,
          nameGap: 25,
        },
        yAxis: {
          type: CATEGORY_TYPE,
          data: axisData,
          name: axisLabels?.[0],
          nameLocation: 'middle' as const,
          nameRotate: 90,
          nameGap: Math.round((chartWidth ?? 800) * 0.12),
          nameTruncate: {
            maxWidth: chartHeight,
          },
        },
      }
    : {
        xAxis: {
          type: CATEGORY_TYPE,
          data: axisData,
          name: axisLabels?.[0],
          nameLocation: 'middle' as const,
          nameGap: axisLabels?.[0] ? 75 : 0,
          axisLabel: {
            interval: 0,
            rotate: 45,
            margin: 10,
            align: ALIGN_RIGHT,
          },
        },
        yAxis: {
          type: VALUE_TYPE,
          name: axisLabels?.[1],
          nameLocation: 'middle' as const,
          nameRotate: 90,
          nameGap: 50,
        },
      };
